import { useCallback, useEffect, useState } from "react";
import { CalendarClock, Send } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const WeeklyDigestCard = () => {
  const [digest, setDigest] = useState(null);
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);
  const [sending, setSending] = useState(false);

  const load = useCallback(async () => {
    try {
      const response = await api.get("/team/weekly-digest/preview");
      setDigest(response.data);
      setError("");
    } catch (requestError) {
      setError(formatApiError(requestError));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  async function sendNow() {
    setSending(true);
    setError("");
    try {
      const response = await api.post("/team/weekly-digest/run");
      setResult(response.data);
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setSending(false);
    }
  }

  if (!digest && !error) return null;
  const counts = digest?.counts || {};
  return (
    <section className="email-delivery-card weekly-digest-card" data-testid="weekly-digest-card">
      <div className="email-delivery-heading">
        <CalendarClock size={18} />
        <div className="email-delivery-copy">
          <strong>Weekly staff digest · every Monday, 8:00 AM ET</strong>
          <span>
            Emails Admin, Operations and Staffing Coordinators a summary of open, overdue and due-this-week evaluations plus
            unfilled positions.
          </span>
        </div>
        <div className="email-delivery-actions">
          <button className="button button-secondary" data-testid="weekly-digest-send-button" disabled={sending} type="button" onClick={sendNow}>
            <Send size={14} /> {sending ? "Sending…" : "Send now"}
          </button>
        </div>
      </div>
      {digest && (
        <div className="weekly-digest-counts" data-testid="weekly-digest-counts">
          <span><strong data-testid="weekly-digest-open">{counts.open_evaluations}</strong> open evaluations</span>
          <span className="is-overdue"><strong data-testid="weekly-digest-overdue">{counts.overdue}</strong> overdue</span>
          <span className="is-due-soon"><strong data-testid="weekly-digest-due-week">{counts.due_this_week}</strong> due this week</span>
          <span><strong data-testid="weekly-digest-unfilled">{counts.unfilled_positions}</strong> unfilled positions</span>
        </div>
      )}
      {result && (
        <p className="team-email-status team-email-sent weekly-digest-result" data-testid="weekly-digest-result">
          Digest delivered to {result.recipients} staff member{result.recipients === 1 ? "" : "s"} in-app
          {result.emails_sent ? ` · ${result.emails_sent} email${result.emails_sent === 1 ? "" : "s"} sent` : ""}
          {result.emails_failed ? ` · ${result.emails_failed} email${result.emails_failed === 1 ? "" : "s"} failed (sender domain not verified)` : ""}
          {result.emails_suppressed ? " · emails are only sent from the live site" : ""}.
        </p>
      )}
      {error && <p className="form-message error-message" data-testid="weekly-digest-error">{error}</p>}
    </section>
  );
};
